import React from 'react';
import { Box, Typography } from '@mui/material';

interface InfoFieldProps {
  label: string;
  value: string | undefined;
  labelMinWidth?: string;
  fontSize?: string;
}

const InfoField: React.FC<InfoFieldProps> = ({
  label,
  value,
  labelMinWidth = '110px',
  fontSize = '13px',
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
    <Typography
      variant="body2"
      fontWeight={600}
      sx={{
        fontSize,
        color: (theme: any) => theme.palette.neutral7?.main,
        minWidth: labelMinWidth,
      }}
    >
      {label}:
    </Typography>
    <Typography variant="body2" sx={{ fontSize, wordBreak: 'break-all', overflowWrap: 'anywhere' }}>
      {value || '-'}
    </Typography>
  </Box>
);

export default InfoField;
